export default "__VITE_ASSET__DwCmGgUb__"